
// @ts-check

import ResultsLoadingManager from "./ResultsLoadingManager";

/**
 *  @typedef {import('./coreTypes').JSResultAtom} JSResultAtom
 */

/** @type {JSResultAtom[]} */
const jsraNull = [];

const ResultsLoadingManagerTVInstance = new ResultsLoadingManager(jsraNull);


export default ResultsLoadingManagerTVInstance;
